import React from "react";

export const MembersIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10.344 7.24a2.241 2.241 0 1 0 4.482 0 2.241 2.241 0 0 0-4.482 0M3.759 8.357a1.863 1.863 0 1 0 3.725 0 1.863 1.863 0 0 0-3.725 0M8.229 13.85a2.99 2.99 0 0 1 2.862-2.128h2.988a2.99 2.99 0 0 1 2.863 2.133M2 13.851a2.48 2.48 0 0 1 2.38-1.769h2.483"
      ></path>
    </svg>
  );
};
